import { CSSProperties } from 'react';
import { borderRadius } from '../../theme/borderRadius';
import { colors, hexToRgbA } from '../../theme/colors';
import spacing, {
  getIsLeftRouterNavigatorShown,
  isMobileScreen,
  spacingInUnits,
} from '../../theme/spacing';
import { fontSize } from '../../theme/typography';
import { BOTTOM_MENU_NAVIGATION_HEIGHT } from '../../routes/BottomRouterNavigation';
import { TOP_MENU_BAR_HEIGHT } from '../TopMenuBar.tsx/constants';

const getModalWidth = () => {
  if (getIsLeftRouterNavigatorShown()) {
    return 1200;
  }
  return isMobileScreen ? '100%' : 1150;
};
export const MODAL_WIDTH = getModalWidth();

export const MODAL_BOTTOM_POSITION = isMobileScreen
  ? 0
  : BOTTOM_MENU_NAVIGATION_HEIGHT;
export const MODAL_MAX_HEIGHT = `calc(100% - ${
  MODAL_BOTTOM_POSITION + BOTTOM_MENU_NAVIGATION_HEIGHT
}px)`;

export const MODAL_FULL_HEIGHT_WITH_BOTTOM_MENU_MAX_HEIGHT = `calc(100% - ${MODAL_BOTTOM_POSITION}px)`;

export const MODAL_TOP_EMPTY_SPACE_HEIGHT = spacingInUnits.mediumPlus;

export const modalPaperFullHeightStyles: CSSProperties = isMobileScreen
  ? {
      height: MODAL_FULL_HEIGHT_WITH_BOTTOM_MENU_MAX_HEIGHT,
      maxHeight: MODAL_FULL_HEIGHT_WITH_BOTTOM_MENU_MAX_HEIGHT,
    }
  : {};

export const modalPaperRootStyles: CSSProperties = {
  backgroundColor: colors.backgroundMediumLight,
  width: MODAL_WIDTH,
  minWidth: MODAL_WIDTH,
  maxWidth: MODAL_WIDTH,
  marginBottom: 0,
  height: MODAL_MAX_HEIGHT,
  maxHeight: MODAL_MAX_HEIGHT,
  position: 'absolute',
  bottom: MODAL_BOTTOM_POSITION,
  overflowX: 'hidden',
};

export const modalPaperRootBackdropStyles: CSSProperties = {
  backgroundColor: hexToRgbA(colors.backgroundMedium, 0.85),
};
export const drawerFromRightLeftSideBorderStyles: CSSProperties = {
  ...(isMobileScreen
    ? {}
    : {
        borderTopLeftRadius: borderRadius.large,
        borderBottomLeftRadius: borderRadius.large,
        borderLeft: `1px solid ${colors.backgroundLight}`,
        borderBottom: `1px solid ${colors.backgroundLight}`,
        borderTop: `1px solid ${colors.backgroundLight}`,
      }),
};

export const drawerPaperFullScreenStyles: CSSProperties = {
  ...modalPaperRootStyles,
  ...drawerFromRightLeftSideBorderStyles,
  height: '100%',
  maxHeight: '100%',
  overflow: 'hidden',
};

export const drawerFromBottomTopBorderRadiusStyles: CSSProperties = {
  borderTopLeftRadius: borderRadius.large,
  borderTopRightRadius: borderRadius.large,
};

export const drawerFromBottomBorderStyles: CSSProperties = {
  // boxShadow: `0 -1px 2.5px ${hexToRgbA(colors.backgroundVeryLight, 0.85)}`,
  ...(isMobileScreen
    ? {}
    : {
        borderTop: `1px solid ${colors.backgroundLight}`,
        borderLeft: `1px solid ${colors.backgroundLight}`,
        borderRight: `1px solid ${colors.backgroundLight}`,
      }),
};

export const drawerFromBottomPaperStyles: CSSProperties = {
  ...(isMobileScreen ? drawerFromBottomTopBorderRadiusStyles : {}),
  width: MODAL_WIDTH,
  minWidth: MODAL_WIDTH,
  maxWidth: MODAL_WIDTH,
  boxSizing: 'border-box',
  overflowX: 'hidden',
  boxShadow: 'none',
  height: `100%`,
  maxHeight: `100%`,
  background: 'transparent',
  margin: '0 auto',
  bottom: 0,
};

export const drawerFromBottomPaperFullHeightStyles: CSSProperties = {
  ...drawerFromBottomPaperStyles,
  ...drawerFromBottomTopBorderRadiusStyles,
  ...drawerFromBottomBorderStyles,
  ...(isMobileScreen
    ? {}
    : {
        height: `calc(100% - ${TOP_MENU_BAR_HEIGHT}px)`,
        maxHeight: `calc(100% - ${TOP_MENU_BAR_HEIGHT}px)`,
      }),
};

export const drawerFromBottomPaperAutoHeightStyles: CSSProperties = {
  ...drawerFromBottomPaperStyles,
  justifyContent: 'flex-end',
};

export const drawerFullScreenWithTopBarContentStyles: CSSProperties = {
  width: MODAL_WIDTH,
  margin: '0 auto',
  overflowY: 'auto',
  height: `calc(100% - ${TOP_MENU_BAR_HEIGHT}px)`,
  maxHeight: `calc(100% - ${TOP_MENU_BAR_HEIGHT}px)`,
};

export const drawerFromBottomContentStyles: CSSProperties = {
  ...drawerFromBottomTopBorderRadiusStyles,
  ...drawerFromBottomBorderStyles,
  overflowY: 'auto',
  height: `calc(100% - ${MODAL_TOP_EMPTY_SPACE_HEIGHT}px)`,
  background: colors.backgroundMediumLight,
};

export const drawerFromBottomContentAutoHeightStyles: CSSProperties = {
  ...drawerFromBottomContentStyles,
  ...drawerFromBottomBorderStyles,
  overflow: 'hidden',
  background: colors.backgroundMediumLight,
  height: 'auto',
  maxHeight: `calc(100% - ${TOP_MENU_BAR_HEIGHT}px)`,
  boxSizing: 'border-box',
};

export const drawerFromBottomScrollableContainerStyles: CSSProperties = {
  ...drawerFromBottomTopBorderRadiusStyles,
  height: '100%',
  overflowY: 'auto',
  boxSizing: 'border-box',
  WebkitOverflowScrolling: 'touch',
};

export const drawerFullHeightBackgroundColor = colors.backgroundMedium;

export const drawerFromBottomContentFullHeightStyles: CSSProperties = {
  ...drawerFromBottomTopBorderRadiusStyles,
  overflowY: 'auto',
  height: '100%',
  borderRadius: 0,
  background: drawerFullHeightBackgroundColor,
};

export const modalTopBarStyles: CSSProperties = {
  height: TOP_MENU_BAR_HEIGHT,
  width: '100%',
  background: modalPaperRootStyles.backgroundColor,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};

export const smallModalPaperRootStyles: CSSProperties = {
  backgroundColor: colors.backgroundMediumLight,
  borderRadius: borderRadius.xs,
  padding: spacing.xs,
};

export const modalCloseIconStyle: CSSProperties = {
  fontSize: fontSize['3xl'],
  position: 'fixed',
  top: spacing.small,
  right: spacing.medium,
  color: colors.white,
  zIndex: 100,
  // border: `2px solid ${colors.textPrimary}`,
  borderRadius: borderRadius.medium,
  padding: spacing.xxs,
  backgroundColor: colors.backgroundMediumLight,
  height: 38,
  width: 38,
  maxHeight: 38,
  maxWidth: 38,
  boxSizing: 'border-box',
  cursor: 'pointer',
};

export const onModalPaperOutsideContentAreaClick = (
  event: React.MouseEvent<HTMLDivElement>,
  closeModal: () => void,
) => {
  if (event.target === event.currentTarget) {
    closeModal();
  }
};
